"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkflowTemplateForm = WorkflowTemplateForm;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _StageActorsPermissionsPopup = require("./StageActorsPermissionsPopup");
var _core = require("@focaltec-suite/core");
var _components = require("../components");
var _FeedbackContext = require("../feedback/FeedbackContext");
var _DataGrid = require("../grid/DataGrid");
var _Model = require("./Model");
var _Workflove = require("./Workflove");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function WorkflowTemplateForm(_ref) {
  var productId = _ref.productId,
    tenantId = _ref.tenantId,
    workflowId = _ref.workflowId,
    templateId = _ref.templateId,
    externalId = _ref.externalId,
    disabled = _ref.disabled,
    getPromise = _ref.getPromise,
    onComplete = _ref.onComplete,
    phaseTranslator = _ref.phaseTranslator;
  var _a;
  var feedbackContext = (0, _react.useContext)(_FeedbackContext.FeedbackContext);
  var _useState = (0, _react.useState)('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    request = _useState4[0],
    setRequest = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    stageActors = _useState6[0],
    setStageActors = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    index = _useState8[0],
    setIndex = _useState8[1];
  (0, _react.useEffect)(function () {
    setStatus('loading');
    Promise.all([(0, _Workflove.getStages)(productId), (0, _Workflove.getActors)(productId), (0, _Workflove.getWorkflowTemplate)(productId, workflowId, tenantId, templateId, externalId)]).then(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 3),
        stages = _ref3[0],
        actors = _ref3[1],
        workflowTemplate = _ref3[2];
      var stagesActors = (0, _Model.calculateStageRoles)(stages, actors, workflowTemplate);
      setRequest(function (r) {
        return Object.assign(Object.assign({}, r), {
          stage_actors: stagesActors !== null && stagesActors !== void 0 ? stagesActors : []
        });
      });
      setStatus('loaded');
    })["catch"](function (error) {
      setStatus(error.message);
    });
  }, [productId, workflowId, tenantId, templateId, externalId]);
  var showPopup = function showPopup(stageActors, index) {
    setStageActors(stageActors);
    setIndex(index);
  };
  var closePopup = function closePopup() {
    setStageActors(undefined);
    setIndex(undefined);
  };
  var onUpdated = function onUpdated(stageActors) {
    if (index === undefined) return;
    if (!request.stage_actors) return;
    var items = request.stage_actors.map(function (el, i) {
      return i === index ? stageActors : el;
    });
    setRequest(Object.assign(Object.assign({}, request), {
      stage_actors: items
    }));
    closePopup();
  };
  var onSubmit = function onSubmit() {
    feedbackContext.showBackdrop();
    getPromise(request).then(function (response) {
      onComplete(response);
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  if (status === 'loading') {
    return /*#__PURE__*/_react["default"].createElement(_components.Progress, null);
  }
  if (status !== 'loaded') {
    return /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body1",
      component: "h5",
      color: "error",
      align: "center"
    }, status);
  }
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body1",
    gutterBottom: true
  }, (0, _core.translate)('workflove.template.header')), /*#__PURE__*/_react["default"].createElement(_material.Card, {
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_DataGrid.DataGrid, {
    items: (_a = request.stage_actors) !== null && _a !== void 0 ? _a : [],
    loading: false,
    getId: function getId(el) {
      return el.stage_id;
    },
    empty: (0, _core.translate)('workflove.template.empty'),
    columns: [{
      title: (0, _core.translate)('workflove.template.title'),
      converter: function converter(stage, index) {
        return stage._stage_name;
      },
      id: 'stage_name'
    }, {
      title: (/*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        size: "small",
        style: {
          visibility: 'hidden'
        },
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement(_components.EditIcon, null))),
      converter: function converter(stage, index, indexRow) {
        var configured = stage.actors && stage.actors.filter(function (actor) {
          return !!actor._checked || actor.fields && actor.fields.filter(function (f) {
            return !!f.read;
          }).length > 0;
        }).length > 0;
        return /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
          "aria-label": "edit",
          color: "primary",
          size: "small",
          disabled: disabled,
          onClick: function onClick() {
            return showPopup(stage, indexRow !== null && indexRow !== void 0 ? indexRow : -1);
          }
        }, configured ? (/*#__PURE__*/_react["default"].createElement(_components.EditIcon, null)) : (/*#__PURE__*/_react["default"].createElement(_components.AddIcon, null)));
      },
      id: 'actions',
      fixed: 'right',
      width: 60,
      textAlign: 'center'
    }]
  }))), /*#__PURE__*/_react["default"].createElement(_components.FormActions, {
    type: "button",
    id: "-",
    onClick: onSubmit
  }), stageActors && index !== undefined && (/*#__PURE__*/_react["default"].createElement(_StageActorsPermissionsPopup.StageActorsPermissionsPopup, {
    stageActor: stageActors,
    onUpdated: onUpdated,
    onClose: closePopup,
    phaseTranslator: phaseTranslator
  })));
}